import React, { useEffect, useState } from 'react'
import { Horizontal, Vertical, ErrorNotification } from '@gravitate-js/excalibrr'
import { IntramonthDirectiveStatus } from '../../DirectiveStatus/Intramonth/IntramonthDirectiveStatus'
import { IntramonthGrid } from './IntramonthGrid'
import { useDirectiveContext } from '../../DirectiveContext'
import api from '@utils/api'
import { DirectivesPage } from '../../DirectivesPage'
import { WeeklySwitch } from '../../DefaultDirectiveFilters'
import { filterDirectives, grabDates, grabFilterOptions, insertRow, sortDirectives } from '../../util'
import { useCancelRequest } from '@components/_SiteWide/API/useCancelRequest'

export const IntramonthPage = () => {
  const [isMonthlyLoading, setIsMonthlyLoading] = useState(true)
  const [unfilteredDirectives, setUnfilteredDirectives] = useState([])
  const [monthlyDirectives, setMonthlyDirectives] = useState([])
  const [activeSort, setActiveSort] = useState()
  const [sortDirection, setSortDirection] = useState()
  const { setServerParams, clearState, selectedDate, filters, setRowCount, selectDirective } = useDirectiveContext()
  const { getCancelToken } = useCancelRequest()
  useEffect(() => {
    clearState()
    setIsMonthlyLoading(true)
    const cancelToken = getCancelToken()
    api.getMonthlyDirectives({ ...grabDates(selectedDate) }, cancelToken).then((resp) => {
      setIsMonthlyLoading(false)
      setServerParams(grabFilterOptions(resp.data.rows, resp.data))
      setUnfilteredDirectives(resp.data.rows)
      let filteredAndSorted = [...resp.data.rows]
      if (filters) {
        filteredAndSorted = filterDirectives(filters, filteredAndSorted)
      }
      if (activeSort) {
        filteredAndSorted = sortDirectives(filteredAndSorted, activeSort, sortDirection)
      }
      setMonthlyDirectives(filteredAndSorted)
      setRowCount(filteredAndSorted.length)
    })
  }, [selectedDate])

  useEffect(() => {
    if (!filters) {
      return
    }
    const filtered = filterDirectives(filters, unfilteredDirectives)
    setMonthlyDirectives(filtered)
    setRowCount(filtered.length)
  }, [filters, isMonthlyLoading])

  useEffect(() => {
    if (!activeSort) {
      return
    }
    const sorted = sortDirectives(monthlyDirectives, activeSort, sortDirection)
    setMonthlyDirectives(sorted)
    setRowCount(sorted.length)
  }, [activeSort, sortDirection])

  const updateRow = (curveGroupId, setRefreshing, setIsExpanded) => {
    setRefreshing(true)
    api
      .getMonthlyDirectives({
        ...grabDates(selectedDate),
        curve_group_id: curveGroupId,
      })
      .then((resp) => {
        if (resp.data?.rows[0]) {
          const updatedRow = resp.data.rows[0]
          insertRow(updatedRow, unfilteredDirectives, monthlyDirectives, setUnfilteredDirectives, setMonthlyDirectives)
          setRefreshing(false)
          setIsExpanded(false)
          selectDirective(updatedRow)
        } else {
          ErrorNotification({
            errorFields: [
              {
                errors: [`Unable to update row.`],
              },
            ],
          })
        }
      })
  }
  const addPricesToRow = (directive, prices) => {
    const updatedRow = { ...directive, prices: prices }
    insertRow(updatedRow, unfilteredDirectives, monthlyDirectives, setUnfilteredDirectives, setMonthlyDirectives)
  }

  return (
    <DirectivesPage SwitchComponent={<WeeklySwitch />}>
      <Horizontal fullHeight className=' my-2'>
        <Vertical flex={4}>
          <IntramonthGrid
            activeSort={activeSort}
            sortDirection={sortDirection}
            setActiveSort={setActiveSort}
            setSortDirection={setSortDirection}
            isMonthlyLoading={isMonthlyLoading}
            monthlyDirectives={monthlyDirectives}
            updateRow={updateRow}
            addPricesToRow={addPricesToRow}
          />
        </Vertical>
        <Vertical flex={3}>
          <IntramonthDirectiveStatus />
        </Vertical>
      </Horizontal>
    </DirectivesPage>
  )
}
